(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-4"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('a4-reviews')) {

  customElements.define('a4-reviews', class extends HTMLElement {

    connectedCallback() {

      queueMicrotask(() => { if (this.isConnected && !this.controller) this.init(); });

    }

    init() {

      this.window = this.querySelector('[data-a4-window]');

      this.track = this.querySelector('[data-a4-track]');

      if (!this.track || !this.window) return;

      this.cards = Array.from(this.track.querySelectorAll('[data-a4-card]:not([data-clone])'));

      this.count = this.cards.length;

      if (!this.count) return;

      this.controller = new AbortController();

      this.signal = this.controller.signal;

      this.motion = matchMedia('(prefers-reduced-motion: reduce)');

      this.mobile = matchMedia('(max-width: 749px)');

      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;

      this.editor = Boolean(window.Shopify && window.Shopify.designMode);

      this.visible = true;

      this.x = 0;

      this.index = 0;

      this.lastTime = 0;

      this.nextTime = performance.now() + this.delay();

      this.holdUntil = performance.now() + 2200;

      this.expanded = new Set();

      this.hasFocus = false;

      this.drag = null;

      this.tween = null;

      this.classList.add('a4-ready');

      this.layout();

      this.on(this, 'click', e => this.click(e));

      this.on(this.window, 'keydown', e => {

        if (e.target.matches('button,a,input,textarea,select')) return;

        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {

          e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1, true);

        }

      });

      this.on(this.window, 'pointerdown', e => this.startDrag(e));

      this.on(this.window, 'pointermove', e => this.moveDrag(e));

      this.on(this.window, 'pointerup', e => this.endDrag(e));

      this.on(this.window, 'pointercancel', e => this.endDrag(e));

      this.on(this.window, 'lostpointercapture', e => this.endDrag(e));

      this.on(this, 'focusin', e => {

        this.hasFocus = true;

        const card = e.target.closest('[data-a4-card]:not([data-clone])');

        if (card && !this.drag && !this.staticMode) {

          const rect = card.getBoundingClientRect(), bounds = this.window.getBoundingClientRect();

          if (rect.left < bounds.left - 2 || rect.right > bounds.right + 2) {

            this.tween = null; this.x = Number(card.dataset.index) * this.step; this.paint();

          }

        }

      });

      this.on(this, 'focusout', () => {

        queueMicrotask(() => { this.hasFocus = this.contains(document.activeElement); this.wake(); });

      });

      this.on(document, 'visibilitychange', () => {

        this.lastTime = 0;

        if (document.hidden) cancelAnimationFrame(this.raf); else this.wake();

      });

      this.on(this.motion, 'change', () => {

        if (this.motion.matches) { this.paused = true; this.tween = null; this.x = this.index * this.step; }

        this.paint(); this.wake();

      });

      this.on(this.mobile, 'change', () => { this.layout(); this.hold(); });

      this.on(this, 'shopify:block:select', e => {

        const card = this.cards.find(c => c.dataset.blockId === e.detail?.blockId);

        if (card) { this.tween = null; this.x = Number(card.dataset.index) * this.step; this.paint(); }

      });

      this.resize = new ResizeObserver(() => {

        const width = this.window.getBoundingClientRect().width;

        const cardWidth = this.cards[0].getBoundingClientRect().width;

        if (Math.abs(width - this.viewportWidth) > .5 || Math.abs(cardWidth - this.cardWidth) > .5) this.layout();

      });

      this.resize.observe(this.window);

      this.resize.observe(this.cards[0]);

      this.intersection = new IntersectionObserver(entries => {

        this.visible = entries[0].isIntersecting;

        this.lastTime = 0;

        if (this.visible) this.wake(); else cancelAnimationFrame(this.raf);

      }, { threshold: 0 });

      this.intersection.observe(this);

      if (this.dataset.reveal === 'true' && !this.motion.matches) {

        this.classList.add('a4-reveal-ready');

        this.reveal = new IntersectionObserver(entries => {

          entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); this.reveal.unobserve(entry.target); } });

        }, { threshold: .05 });

        this.querySelectorAll('[data-a4-reveal]').forEach(el => this.reveal.observe(el));

      }

      if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected && this.controller) this.layout(); });

      this.wake();

    }

    on(target, type, fn) { target.addEventListener(type, fn, { signal: this.signal }); }

    delay() { return 2000; }

    hold() { this.holdUntil = performance.now() + 2000; this.nextTime = performance.now() + this.delay(); }

    layout() {

      const current = this.step ? this.x / this.step : 0;

      this.track.querySelectorAll('[data-clone]').forEach(el => el.remove());

      this.viewportWidth = this.window.getBoundingClientRect().width;

      this.cardWidth = this.cards[0].getBoundingClientRect().width;

      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;

      this.step = this.cardWidth + gap;

      this.cycle = this.step * this.count;

      this.staticMode = this.count < 2 || this.cycle - gap <= this.viewportWidth + 1;

      this.classList.toggle('is-static', this.staticMode);

      this.tween = null;

      this.drag = null;

      this.base = 0;

      this.cards.forEach(card => {

        const text = card.querySelector('.a4-text'), read = card.querySelector('[data-a4-read]');

        if (text && read) read.hidden = !this.expanded.has(Number(card.dataset.index)) && text.scrollHeight <= text.clientHeight + 2;

      });

      if (!this.staticMode) {

        const copies = Math.ceil(this.viewportWidth / this.cycle) + 1;

        const before = document.createDocumentFragment(), after = document.createDocumentFragment();

        for (let group = 0; group < copies; group++) {

          this.cards.forEach(card => { before.append(this.cloneCard(card, 'before-' + group)); after.append(this.cloneCard(card, 'after-' + group)); });

        }

        this.track.prepend(before); this.track.append(after);

        this.base = copies * this.cycle;

      }

      this.x = current * this.step;

      this.window.scrollLeft = 0;

      this.paint(); this.wake();

    }

    cloneCard(card, suffix) {

      const clone = card.cloneNode(true);

      clone.dataset.clone = 'true';

      clone.removeAttribute('data-shopify-editor-block');

      clone.setAttribute('aria-hidden', 'true');

      const text = clone.querySelector('.a4-text'), read = clone.querySelector('[data-a4-read]');

      if (text) text.id += '-' + suffix;

      if (read && text) read.setAttribute('aria-controls', text.id);

      clone.querySelectorAll('button,a,[tabindex]').forEach(el => el.tabIndex = -1);

      return clone;

    }

    norm(value) { return this.cycle ? ((value % this.cycle) + this.cycle) % this.cycle : 0; }

    paint() {

      const offset = this.norm(this.x);

      this.track.style.transform = this.staticMode ? '' : 'translate3d(' + -(this.base + offset) + 'px,0,0)';

      this.index = Math.round(offset / this.step) % this.count;

      const position = this.querySelector('[data-a4-pos]');

      if (position) position.textContent = String(this.index + 1).padStart(2, '0');

      const progress = this.querySelector('[data-a4-progress]');

      if (progress) progress.style.transform = 'scaleX(' + ((this.index + 1) / this.count) + ')';

    }

    move(direction, announce) {

      if (this.staticMode) return;

      const destination = (Math.round((this.tween ? this.tween.to : this.x) / this.step) + direction) * this.step;

      this.go(destination, announce);

    }

    go(destination, announce) {

      this.hold();

      if (this.motion.matches) { this.tween = null; this.x = destination; this.paint(); }

      else this.tween = { from: this.x, to: destination, start: performance.now() };

      if (announce) {

        const index = Math.round(this.norm(destination) / this.step) % this.count;

        this.querySelector('[data-a4-status]').textContent = this.dataset.positionLabel + ' ' + (index + 1) + ' / ' + this.count;

      }

      this.wake();

    }

    click(event) {

      if (this.suppressClick) { event.preventDefault(); this.suppressClick = false; return; }

      if (event.target.closest('[data-a4-prev]')) this.move(-1, true);

      if (event.target.closest('[data-a4-next]')) this.move(1, true);

      const read = event.target.closest('[data-a4-read]');

      if (read) {

        const index = Number(read.closest('[data-a4-card]').dataset.index);

        const expanded = !this.expanded.has(index);

        if (expanded) this.expanded.add(index); else this.expanded.delete(index);

        this.querySelectorAll('[data-a4-card]').forEach(card => {

          if (Number(card.dataset.index) !== index) return;

          card.classList.toggle('is-expanded', expanded);

          const button = card.querySelector('[data-a4-read]');

          if (button) { button.setAttribute('aria-expanded', String(expanded)); button.querySelector('span').textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel; }

        });

        this.tween = null; this.hold(); this.wake();

      }

    }

    startDrag(event) {

      if (this.staticMode || event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0) || event.target.closest('button,a')) return;

      this.tween = null;

      this.drag = { id: event.pointerId, clientX: event.clientX, clientY: event.clientY, start: this.x, moved: false };

      this.hold();

    }

    moveDrag(event) {

      const drag = this.drag;

      if (!drag || event.pointerId !== drag.id) return;

      const dx = event.clientX - drag.clientX, dy = event.clientY - drag.clientY;

      if (!drag.moved && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { this.drag = null; return; }

      if (!drag.moved && Math.abs(dx) < 6) return;

      if (!drag.moved) { drag.moved = true; this.window.setPointerCapture(event.pointerId); this.classList.add('is-dragging'); }

      this.x = drag.start - dx;

      this.paint();

    }

    endDrag(event) {

      const drag = this.drag;

      if (!drag || event.pointerId !== drag.id) return;

      this.drag = null;

      this.classList.remove('is-dragging');

      if (this.window.hasPointerCapture(event.pointerId)) this.window.releasePointerCapture(event.pointerId);

      if (drag.moved) {

        this.suppressClick = true;

        clearTimeout(this.clickTimer);

        this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 50);

        const moved = this.x - drag.start;

        const target = Math.abs(moved) > 35 && Math.abs(moved) < this.step / 2 ? Math.round(drag.start / this.step) + Math.sign(moved) : Math.round(this.x / this.step);

        this.go(target * this.step, true);

      } else this.hold();

    }

    wake() {

      cancelAnimationFrame(this.raf);

      if (!this.controller || !this.isConnected || !this.visible || document.hidden || this.staticMode) return;

      this.raf = requestAnimationFrame(time => this.tick(time));

    }

    tick(time) {

      const dt = this.lastTime ? Math.min(time - this.lastTime, 50) : 0;

      this.lastTime = time;

      if (this.tween) {

        const p = Math.min((time - this.tween.start) / 500, 1);

        this.x = this.tween.from + (this.tween.to - this.tween.from) * (1 - Math.pow(1 - p, 3));

        if (p === 1) { this.tween = null; this.x = this.norm(this.x); }

        this.paint();

      } else if (!this.paused && !this.editor && !this.drag && !this.hasFocus && !this.expanded.size && time > this.holdUntil) {

        if (this.motion.matches) {

          if (time >= this.nextTime) this.move(1, false);

        } else {

          this.x = this.norm(this.x + (Number(this.dataset.speed) || .4) * 60 * dt / 1000);

          this.paint();

        }

      }

      this.wake();

    }

    disconnectedCallback() {

      this.controller?.abort();

      this.controller = null;

      this.resize?.disconnect(); this.intersection?.disconnect(); this.reveal?.disconnect();

      cancelAnimationFrame(this.raf); clearTimeout(this.clickTimer);

      this.querySelectorAll('[data-clone]').forEach(el => el.remove());

      this.classList.remove('a4-ready', 'a4-reveal-ready', 'is-dragging');

      if (this.track) this.track.style.transform = '';

    }

  });

}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-12"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-collection12-section]';

    class Collection12 {
      constructor(root) {
        if (!root || root.dataset.c12Initialized === 'true') return;

        this.root = root;
        this.root.dataset.c12Initialized = 'true';
        this.tabs = Array.from(root.querySelectorAll('[data-c12-tab]'));
        this.panels = Array.from(root.querySelectorAll('[data-c12-panel]'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.switching = false;
        this.switchTimer = null;
        this.finishTimer = null;
        this.resizeFrame = null;

        this.onRootClick = this.onRootClick.bind(this);
        this.onRootKeydown = this.onRootKeydown.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.root.addEventListener('click', this.onRootClick);
        this.root.addEventListener('keydown', this.onRootKeydown);
        this.root.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('resize', this.onResize, { passive: true });

        this.panels.forEach((panel) => {
          const track = panel.querySelector('[data-c12-track]');
          if (track) {
            track.addEventListener('scroll', () => {
              window.requestAnimationFrame(() => this.updateArrows(panel));
            }, { passive: true });
          }
        });

        this.reveal();
      }

      reveal() {
        window.requestAnimationFrame(() => {
          this.root.classList.add('is-visible');
          const activePanel = this.getActivePanel() || this.panels[0];
          this.animateCards(activePanel);
          this.centerAllTracks();
          this.updateArrows(activePanel);
        });
      }

      getActivePanel() {
        return this.root.querySelector('[data-c12-panel].is-active');
      }

      getActiveIndex() {
        const activePanel = this.getActivePanel();
        return activePanel ? Number(activePanel.dataset.c12Panel) : 0;
      }

      applyTheme(tab) {
        if (!tab) return;
        this.root.style.setProperty('--c12-bg', tab.dataset.c12Bg);
        this.root.style.setProperty('--c12-card-bg', tab.dataset.c12CardBg);
        this.root.style.setProperty('--c12-accent', tab.dataset.c12Accent);
        this.root.style.setProperty('--c12-text', tab.dataset.c12Text);
        this.root.style.setProperty('--c12-muted', tab.dataset.c12Muted);
      }

      animateCards(panel) {
        if (!panel) return;
        const cards = panel.querySelectorAll('.collection12__card');
        cards.forEach((card) => card.classList.remove('is-in'));

        if (this.reducedMotion) {
          cards.forEach((card) => card.classList.add('is-in'));
          return;
        }

        void panel.offsetWidth;
        window.requestAnimationFrame(() => {
          cards.forEach((card) => card.classList.add('is-in'));
        });
      }

      centerTrack(track) {
        if (!track) return;
        track.classList.toggle('is-centered', track.scrollWidth <= track.clientWidth + 4);
      }

      centerAllTracks() {
        this.panels.forEach((panel) => this.centerTrack(panel.querySelector('[data-c12-track]')));
      }

      updateArrows(panel = this.getActivePanel()) {
        if (!panel) return;
        const track = panel.querySelector('[data-c12-track]');
        const previous = panel.querySelector('[data-c12-previous]');
        const next = panel.querySelector('[data-c12-next]');
        if (!track || !previous || !next) return;

        const maximum = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum;
      }

      setSelectedTab(index) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
      }

      activate(index, immediate = false) {
        const nextPanel = this.panels[index];
        const nextTab = this.tabs[index];
        const currentPanel = this.getActivePanel();
        const currentIndex = this.getActiveIndex();

        if (!nextPanel || index === currentIndex || (this.switching && !immediate)) {
          if (nextTab) this.applyTheme(nextTab);
          return;
        }

        window.clearTimeout(this.switchTimer);
        window.clearTimeout(this.finishTimer);
        this.switching = true;
        this.setSelectedTab(index);
        this.applyTheme(nextTab);

        const completeSwitch = () => {
          if (currentPanel) {
            currentPanel.classList.remove('is-active', 'is-leaving');
            currentPanel.hidden = true;
            currentPanel.setAttribute('aria-hidden', 'true');
          }

          nextPanel.hidden = false;
          nextPanel.setAttribute('aria-hidden', 'false');
          nextPanel.classList.add('is-active');
          this.animateCards(nextPanel);
          this.centerTrack(nextPanel.querySelector('[data-c12-track]'));
          this.updateArrows(nextPanel);

          if (nextTab && window.innerWidth < 750) {
            nextTab.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
          }

          this.finishTimer = window.setTimeout(() => {
            this.root.classList.remove('is-changing');
            this.switching = false;
          }, immediate || this.reducedMotion ? 0 : 620);
        };

        if (immediate || this.reducedMotion || !currentPanel) {
          completeSwitch();
          return;
        }

        this.root.classList.add('is-changing');
        currentPanel.classList.remove('is-active');
        currentPanel.classList.add('is-leaving');
        this.switchTimer = window.setTimeout(completeSwitch, 260);
      }

      scrollProducts(button, direction) {
        const panel = button.closest('[data-c12-panel]');
        const track = panel?.querySelector('[data-c12-track]');
        const card = track?.querySelector('.collection12__card');
        if (!track) return;

        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.82;
        track.scrollBy({ left: direction * step, behavior: this.reducedMotion ? 'auto' : 'smooth' });
      }

      onRootClick(event) {
        const tab = event.target.closest('[data-c12-tab]');
        if (tab && this.root.contains(tab)) {
          this.activate(Number(tab.dataset.c12Tab));
          return;
        }

        const previous = event.target.closest('[data-c12-previous]');
        if (previous && this.root.contains(previous)) {
          this.scrollProducts(previous, -1);
          return;
        }

        const next = event.target.closest('[data-c12-next]');
        if (next && this.root.contains(next)) {
          this.scrollProducts(next, 1);
        }
      }

      onRootKeydown(event) {
        const tab = event.target.closest('[data-c12-tab]');
        if (!tab || !this.root.contains(tab) || this.tabs.length < 2) return;

        const currentIndex = this.tabs.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.tabs[nextIndex].focus();
        this.activate(nextIndex);
      }

      onResize() {
        window.cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = window.requestAnimationFrame(() => {
          this.centerAllTracks();
          this.updateArrows();
        });
      }

      onBlockSelect(event) {
        const panel = event.target.closest('[data-c12-panel]');
        if (!panel || !this.root.contains(panel)) return;
        this.activate(Number(panel.dataset.c12Panel), true);
      }
    }

    const initialize = (scope = document) => {
      if (scope.matches?.(SELECTOR)) new Collection12(scope);
      scope.querySelectorAll?.(SELECTOR).forEach((root) => new Collection12(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPageCollection = (section) => {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const grid = section.querySelector('[data-collection-grid]');
      const cards = Array.from(section.querySelectorAll('[data-collection-card]'));
      const filters = Array.from(section.querySelectorAll('[data-filter]'));
      const count = section.querySelector('[data-collection-count]');
      const note = section.querySelector('[data-collection-note]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rows = [1, 1, 2, 3];

      const formatCount = (value) => String(value).padStart(2, '0');

      const applyLayout = (visibleCards) => {
        cards.forEach((card) => {
          card.classList.remove(
            'page-collection__card--slot-1',
            'page-collection__card--slot-2',
            'page-collection__card--slot-3',
            'page-collection__card--slot-4'
          );
        });

        visibleCards.forEach((card, index) => {
          const group = Math.floor(index / 4);
          const pattern = index % 4;
          card.classList.add(`page-collection__card--slot-${pattern + 1}`);
          card.style.gridRow = String(group * 3 + rows[pattern]);
        });

        if (count) count.textContent = formatCount(visibleCards.length);
        if (note) note.classList.toggle('is-hidden', visibleCards.length < 4);
      };

      const revealCard = (card, delay = 0) => {
        window.setTimeout(() => card.classList.add('is-revealed'), delay);
      };

      const setFilter = (category) => {
        if (!grid) return;
        grid.classList.add('is-switching');

        window.setTimeout(() => {
          const visibleCards = cards.filter((card) => {
            const matches = category === 'all' || card.dataset.category === category;
            card.hidden = !matches;
            return matches;
          });

          applyLayout(visibleCards);

          visibleCards.forEach((card, index) => {
            card.classList.remove('is-revealed');
            void card.offsetWidth;
            revealCard(card, reducedMotion ? 0 : index * 90);
          });

          grid.classList.remove('is-switching');
          requestParallax();
        }, reducedMotion ? 0 : 300);
      };

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.classList.contains('is-active')) return;

          filters.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          setFilter(button.dataset.filter || 'all');
        });
      });

      const revealObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add(entry.target === note ? 'is-revealed' : 'is-revealed');
              observer.unobserve(entry.target);
            });
          }, { threshold: 0.14, rootMargin: '0px 0px -5% 0px' })
        : null;

      if ('IntersectionObserver' in window) {
        const sectionObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            section.classList.add('is-visible');
            observer.unobserve(section);
          });
        }, { threshold: 0.06 });
        sectionObserver.observe(section);
      } else {
        section.classList.add('is-visible');
      }

      cards.forEach((card) => {
        if (revealObserver) revealObserver.observe(card);
        else card.classList.add('is-revealed');
      });

      if (note) {
        if (revealObserver) revealObserver.observe(note);
        else note.classList.add('is-revealed');
      }

      let ticking = false;
      const updateParallax = () => {
        ticking = false;
        if (reducedMotion) return;

        const viewportHeight = window.innerHeight;
        cards.forEach((card) => {
          if (card.hidden) return;
          const image = card.querySelector('.page-collection__image');
          if (!image) return;

          const rect = card.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > viewportHeight) return;

          const progress = (rect.top + rect.height / 2 - viewportHeight / 2) / viewportHeight;
          const speed = Number.parseFloat(card.dataset.speed || '0.06');
          image.style.setProperty('--pc-parallax', `${(-progress * speed * 100).toFixed(2)}%`);
        });
      };

      function requestParallax() {
        if (reducedMotion || ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateParallax);
      }

      if (!reducedMotion) {
        window.addEventListener('scroll', requestParallax, { passive: true });
        window.addEventListener('resize', requestParallax, { passive: true });
        updateParallax();
      }

      applyLayout(cards);
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-page-collection]').forEach(initPageCollection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-devis"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPageDevis(root) {
      if (!root || root.dataset.pdInitialized === 'true') return;
      root.dataset.pdInitialized = 'true';

      var cards = root.querySelectorAll('[data-pd-offer-card]');
      var chosen = root.querySelector('[data-pd-chosen]');
      var offerInput = root.querySelector('[data-pd-offer-input]');
      var submitBtn = root.querySelector('[data-pd-submit]');
      var errorEl = root.querySelector('[data-pd-error]');
      var form = root.querySelector('[data-pd-form]');
      var formCard = root.querySelector('[data-pd-form-card]');
      var formBody = root.querySelector('[data-pd-form-body]');
      var fileInput = root.querySelector('[data-pd-file]');
      var fileName = root.querySelector('[data-pd-file-name]');
      var drop = root.querySelector('[data-pd-drop]');
      var formEndpoint = (root.dataset.formEndpoint || '').trim();
      var contactEmail = (root.dataset.contactEmail || '').trim();
      var state = { offer: '', paymentUrl: '' };
      var chipData = {};

      function escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function scrollToForm() {
        if (!formCard) return;
        formCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function selectCard(card, shouldScroll) {
        cards.forEach(function (item) { item.classList.remove('is-active'); });
        card.classList.add('is-active');
        state.offer = card.getAttribute('data-offer') || '';
        state.paymentUrl = card.getAttribute('data-payment-url') || '';
        if (chosen) chosen.textContent = state.offer;
        if (offerInput) offerInput.value = state.offer;
        if (submitBtn) submitBtn.disabled = !state.offer;
        if (errorEl) errorEl.style.display = 'none';
        if (shouldScroll) scrollToForm();
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { selectCard(card, true); });
        var button = card.querySelector('[data-pd-select]');
        if (button) {
          button.addEventListener('click', function (event) {
            event.stopPropagation();
            selectCard(card, true);
          });
        }
      });

      if (cards.length) selectCard(cards[0], false);

      root.querySelectorAll('[data-pd-chip-group]').forEach(function (group) {
        var single = group.getAttribute('data-single') === 'true';
        var name = group.getAttribute('data-name') || '';

        function sync() {
          var values = [];
          group.querySelectorAll('.pd-chip.is-active').forEach(function (chip) {
            values.push(chip.textContent.trim());
          });
          chipData[name] = values.join(', ');
        }

        group.querySelectorAll('.pd-chip').forEach(function (chip) {
          chip.addEventListener('click', function () {
            if (single) {
              group.querySelectorAll('.pd-chip').forEach(function (item) { item.classList.remove('is-active'); });
              chip.classList.add('is-active');
            } else {
              chip.classList.toggle('is-active');
            }
            sync();
          });
        });
      });

      if (fileInput && fileName && drop) {
        fileInput.addEventListener('change', function () {
          if (fileInput.files && fileInput.files.length) {
            fileName.textContent = '✓ ' + fileInput.files[0].name;
            drop.classList.add('has-file');
          } else {
            fileName.textContent = '';
            drop.classList.remove('has-file');
          }
        });
      }

      function showSuccess() {
        if (!formBody) return;
        var paymentSentence = state.paymentUrl
          ? ' Tu vas maintenant être redirigé vers le paiement.'
          : ' Ta décoratrice te recontacte sous 48 h pour lancer le projet.';

        formBody.innerHTML =
          '<div class="pd-success">' +
            '<div class="pd-success-icon">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l4 4L19 6"/></svg>' +
            '</div>' +
            '<h3>Demande bien reçue</h3>' +
            '<p>Merci ! Ta demande pour la formule « ' + escapeHtml(state.offer) + ' » est enregistrée.' + paymentSentence + '</p>' +
          '</div>';

        scrollToForm();
      }

      function afterSend() {
        showSuccess();
        if (state.paymentUrl) {
          window.setTimeout(function () { window.location.href = state.paymentUrl; }, 900);
        }
      }

      if (!form) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!state.offer) {
          if (errorEl) errorEl.style.display = 'block';
          scrollToForm();
          return;
        }

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Envoi en cours…';
        }

        var formData = new FormData(form);
        Object.keys(chipData).forEach(function (key) {
          formData.append(key, chipData[key]);
        });

        if (formEndpoint) {
          fetch(formEndpoint, {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' }
          })
            .then(function (response) {
              if (!response.ok) throw new Error('send failed');
              return response.json().catch(function () { return {}; });
            })
            .then(afterSend)
            .catch(function () {
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = 'Réessayer';
              }
              if (errorEl) {
                errorEl.textContent = contactEmail
                  ? 'L’envoi a échoué. Réessaie ou écris-nous à ' + contactEmail + '.'
                  : 'L’envoi a échoué. Vérifie l’adresse du formulaire dans les réglages de la section.';
                errorEl.style.display = 'block';
              }
            });
          return;
        }

        if (contactEmail) {
          var lines = [];
          formData.forEach(function (value, key) {
            if (key !== 'Plan du projet' && String(value).trim() !== '') {
              lines.push(key + ' : ' + value);
            }
          });

          var fileNote = '';
          if (fileInput && fileInput.files && fileInput.files.length) {
            fileNote = '\n\nPlan à joindre manuellement : ' + fileInput.files[0].name;
          }

          var subject = encodeURIComponent('Demande de devis déco — ' + state.offer);
          var body = encodeURIComponent(lines.join('\n') + fileNote);
          window.location.href = 'mailto:' + contactEmail + '?subject=' + subject + '&body=' + body;
          window.setTimeout(afterSend, 600);
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Réessayer';
        }
        if (errorEl) {
          errorEl.textContent = 'Ajoute un endpoint de formulaire ou une adresse e-mail dans les réglages de la section.';
          errorEl.style.display = 'block';
        }
      });
    }

    function initAllPageDevis() {
      document.querySelectorAll('.pd-section').forEach(initPageDevis);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllPageDevis);
    } else {
      initAllPageDevis();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector ? event.target.querySelector('.pd-section') : null;
      if (root) initPageDevis(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["picots"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('picots-section')) return;
  class PicotsSection extends HTMLElement {
    connectedCallback() {
      this.boot = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.boot);
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.stopMotion();
    }
    init() {
      if (!this.isConnected) return;
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      this.blocks = [...this.querySelectorAll('[data-p-block]')];
      this.layouts = [...this.querySelectorAll('[data-p-connect-layout]')];
      this.progress = this.querySelector('.picots-progress');
      this.animations = new Set();
      this.live = new Set();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.listen = (target, event, fn, options = {}) => target.addEventListener(event, fn, {...options, signal});
      this.listen(window, 'resize', () => this.measure(), {passive: true});
      this.listen(window, 'scroll', () => this.schedule(), {passive: true});
      this.listen(this.reduced, 'change', () => this.applyMotion());
      this.listen(this, 'load', () => this.measure(), {capture: true});
      this.listen(this, 'toggle', () => this.measure(), {capture: true});
      this.listen(this, 'focusin', () => this.finishAnimations());
      this.listen(window, 'beforeprint', () => this.finishAnimations());
      this.listen(document, 'visibilitychange', () => {
        if (document.hidden) this.finishAnimations();
        else this.schedule();
      });
      this.listen(document, 'shopify:block:select', event => {
        if (this.contains(event.target)) this.finishAnimations();
      });
      this.listen(document, 'shopify:section:reorder', () => this.measure());
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this);
        this.blocks.forEach(block => this.resizeObserver.observe(block));
      }
      if (document.fonts?.ready) document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
      this.measure();
      this.applyMotion();
    }
    measure() {
      const width = document.documentElement.clientWidth;
      if (this.viewportWidth !== width) {
        this.viewportWidth = width;
        this.style.setProperty('--p-viewport', `${width}px`);
      }
      this.needsLines = true;
      this.schedule();
    }
    schedule() {
      if (!this.frame && !document.hidden) this.frame = requestAnimationFrame(() => this.render());
    }
    render() {
      this.frame = 0;
      if (!this.isConnected) return;
      if (this.needsLines) {
        this.needsLines = false;
        this.drawLines();
      }
      if (!this.motionActive) return;
      const viewport = window.innerHeight;
      const page = this.getBoundingClientRect();
      const clamp = value => Math.max(0, Math.min(1, value));
      const length = Math.max(1, page.height - viewport);
      this.progress.style.transform = `scaleX(${clamp(-page.top / length)})`;
      const strong = this.dataset.level === 'strong';
      const parallax = this.dataset.parallax === 'true';
      const narrow = this.viewportWidth < 750;
      const positions = [...this.live].map(block => ({block, rect: block.getBoundingClientRect()}));
      positions.forEach(({block, rect}) => {
        if (block.dataset.animate !== 'true') return;
        const passage = clamp((viewport - rect.top) / (viewport + rect.height));
        const drift = parallax ? (passage - .5) * (narrow ? 14 : strong ? 52 : 24) : 0;
        block.style.setProperty('--p-shift', `${drift.toFixed(2)}px`);
        block.style.setProperty('--p-zoom', parallax ? (1.13 - passage * .05).toFixed(3) : '1');
        block.style.setProperty('--p-float', `${(drift * .4).toFixed(2)}px`);
        block.style.setProperty('--p-angle', `${parallax ? ((passage - .5) * 3).toFixed(2) : 0}deg`);
        block.style.setProperty('--p-line-progress', clamp((viewport * .88 - rect.top) / Math.max(1, rect.height * .7)).toFixed(3));
      });
    }
    drawLines() {
      const ns = 'http://www.w3.org/2000/svg';
      this.layouts.forEach(layout => {
        const svg = layout.querySelector('.picots-connectors');
        const box = layout.getBoundingClientRect();
        if (!svg || !box.width || this.viewportWidth < 750) return;
        const source = layout.querySelector('[data-p-connect-source]').getBoundingClientRect();
        const targets = [...layout.querySelectorAll('[data-p-connect-target]')].map(el => el.getBoundingClientRect());
        const signature = [box.width, box.height, source.left-box.left, source.top-box.top, source.width, source.height, ...targets.flatMap(t => [t.left-box.left,t.top-box.top,t.width,t.height])].map(v => Math.round(v)).join(',');
        if (svg.dataset.geometry === signature) return;
        svg.dataset.geometry = signature;
        svg.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`);
        const fragment = document.createDocumentFragment();
        targets.forEach((target, index) => {
          const right = target.left > source.left + source.width / 2;
          const x1 = (right ? source.right - source.width * .04 : source.left + source.width * .04) - box.left;
          const fraction = targets.length === 4 ? .35 + (index % 2) * .3 : .23 + index * .27;
          const y1 = source.top - box.top + source.height * fraction;
          const x2 = (right ? target.left : target.right) - box.left;
          const y2 = target.top - box.top + target.height * .5;
          const mid = (x1 + x2) / 2;
          const path = document.createElementNS(ns, 'path');
          path.setAttribute('d', `M${x1} ${y1} L${mid} ${y1} L${x2} ${y2}`);
          path.setAttribute('pathLength', '200');
          fragment.append(path);
          if (this.motionActive && layout.closest('[data-p-block]').dataset.animate === 'true') {
            const beam = path.cloneNode(false);
            beam.classList.add('picots-beam');
            fragment.append(beam);
          }
          const dot = document.createElementNS(ns, 'circle');
          dot.setAttribute('cx', x1);
          dot.setAttribute('cy', y1);
          dot.setAttribute('r', '3');
          fragment.append(dot);
        });
        svg.replaceChildren(fragment);
      });
    }
    track(animation) {
      this.animations.add(animation);
      const done = () => {
        this.animations.delete(animation);
        if (this.isConnected) {
          this.needsLines = true;
          this.schedule();
        }
      };
      animation.addEventListener('finish', done, {once: true});
      animation.addEventListener('cancel', done, {once: true});
    }
    finishAnimations() {
      this.animations?.forEach(animation => { try { animation.finish(); } catch (_) { animation.cancel(); } });
      this.animations?.clear();
    }
    stopMotion() {
      this.revealObserver?.disconnect();
      this.blockObserver?.disconnect();
      this.finishAnimations();
      this.motionActive = false;
      this.classList.remove('picots-motion');
      this.live?.clear();
      this.querySelectorAll('.picots-beam').forEach(el => el.remove());
      this.querySelectorAll('.picots-connectors').forEach(el => delete el.dataset.geometry);
      this.blocks?.forEach(block => {
        block.classList.remove('picots-inview');
        ['--p-shift','--p-zoom','--p-float','--p-angle','--p-line-progress'].forEach(name => block.style.removeProperty(name));
      });
    }
    applyMotion() {
      this.stopMotion();
      this.needsLines = true;
      if (this.dataset.motion !== 'true' || this.reduced.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) {
        this.schedule();
        return;
      }
      this.motionActive = true;
      this.classList.add('picots-motion');
      const seen = new WeakMap();
      const repeat = this.dataset.repeat === 'true';
      this.revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || entry.intersectionRatio < .08) return;
          const element = entry.target;
          const now = performance.now();
          if (now - (seen.get(element) ?? -Infinity) < 1800 || element.contains(document.activeElement)) return;
          seen.set(element, now);
          this.reveal(element);
          if (!repeat) this.revealObserver.unobserve(element);
        });
      }, {threshold: .08, rootMargin: '0px 0px -3% 0px'});
      this.blocks.forEach(block => {
        if (block.dataset.animate !== 'true') return;
        [...block.querySelectorAll('[data-p-reveal]')].forEach((element, index) => {
          element.dataset.delay = String(Math.min(index * 90, 360));
          this.revealObserver.observe(element);
        });
      });
      this.blockObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.target.classList.toggle('picots-inview', entry.isIntersecting);
          if (entry.isIntersecting) this.live.add(entry.target);
          else this.live.delete(entry.target);
          if (entry.isIntersecting && entry.target.dataset.animate === 'true') {
            entry.target.querySelectorAll('.picots-connectors path:not(.picots-beam)').forEach(path => {
              if (path.dataset.revealed) return;
              path.dataset.revealed = 'true';
              this.track(path.animate([{strokeDasharray:'200',strokeDashoffset:200},{strokeDasharray:'200',strokeDashoffset:0}], {duration:1400,delay:250,easing:'ease-out'}));
            });
          }
        });
        this.schedule();
      }, {rootMargin: '70px 0px'});
      this.blocks.forEach(block => this.blockObserver.observe(block));
      this.schedule();
    }
    reveal(element) {
      const strong = this.dataset.level === 'strong';
      const narrow = this.viewportWidth < 750;
      const distance = narrow ? 24 : strong ? 46 : 22;
      const type = element.dataset.pReveal;
      let frames = [{opacity:.15,transform:`translate3d(0,${distance}px,0)`},{opacity:1,transform:'translate3d(0,0,0)'}];
      if (type === 'photo') frames = [{opacity:.3,transform:'translateY(22px) scale(1.05)'},{opacity:1,transform:'translateY(0) scale(1)'}];
      if (type === 'fade') frames = [{opacity:.3},{opacity:1}];
      if (strong && element.matches('.picots-zone-card,.picots-anatomy-card,.picots-intensity-card,.picots-comfort')) {
        frames = [{opacity:.15,transform:`perspective(950px) translateY(${distance}px) rotateX(7deg) scale(.965)`},{opacity:1,transform:'perspective(950px) translateY(0) rotateX(0) scale(1)'}];
      }
      if (strong && element.matches('.picots-heading')) {
        frames[0].clipPath = 'inset(0 0 80% 0)';
        frames[1].clipPath = 'inset(0 0 0 0)';
      }
      this.track(element.animate(frames, {duration:Number(this.dataset.duration) || 1100,delay:Math.min(Number(element.dataset.delay) || 0,narrow ? 180 : 360),easing:'cubic-bezier(.2,.7,.2,1)',fill:'backwards'}));
    }
  }
  customElements.define('picots-section', PicotsSection);
})();


  } catch(e) { console.error(e); }
})();
})();
